export const GET_FLOW = 'GET_FLOW';
export const QUERY_URL = 'QUERY_URL';
export const GET_THEME = 'GET_THEME';
export const CLEAR_THEME = 'CLEAR_THEME';
export const USER_CUSTOM = 'USER_CUSTOM';
export const SET_CAPTURE_FLOW = 'SET_CAPTURE_FLOW';
export const SET_CAPTURE_SKIP = 'SET_CAPTURE_SKIP';
export const SET_THEME = 'SET_THEME';
export const SET_PHOTO_DISPUTE = 'SET_PHOTO_DISPUTE';
export const SET_CURRENT_STAGE = 'SET_CURRENT_STAGE';
